import { OpCreationConfig } from "../../operationalise";
import { LowLevelFragmentList, VizFragment } from "./low-level-fragment";

export enum GenerationFragmentType {
  UNSET = "UNSET",
  OP10ZE = "OP10ZE",
  WIDGET = "WIDGET",
  DASHBOARD = "DASHBOARD"
}

export enum GenerationType {
  UNSET = "UNSET",
  RELATED_KPIS = "RELATED_KPIS",
  DASHBOARD = "DASHBOARD"
}

export type GenerateDashboardContext = {
  generationType: GenerationType;
};

export type GenerationFragment = {
  fragmentType: GenerationFragmentType;

  // oneOf
  opCreationConfig?: OpCreationConfig;
  vizFragment?: VizFragment;

  // KPIs, dimensions context
  lowLevelFragmentList?: LowLevelFragmentList;

  dashboardContext?: GenerateDashboardContext;
};
